import { getResourceCode } from '../';
import { $definitions, ALLERGY_CLINICAL_STATUS_SELECT_ID, ALLERGY_TYPE_SELECT_ID, ALLERGY_VERIFICATION_STATUS_SELECT_ID, } from '../../definitions';
export class AllergyExtractor {
    constructor(resource, additional = {}) {
        this._data = resource;
        this.additional = additional;
    }
    get data() {
        return this._data;
    }
    get code() {
        return getResourceCode(this.data.code);
    }
    get status() {
        return $definitions.selects.getValue(ALLERGY_CLINICAL_STATUS_SELECT_ID, this.data.clinicalStatus || this.additional.status);
    }
    get verificationStatus() {
        return $definitions.selects.getValue(ALLERGY_VERIFICATION_STATUS_SELECT_ID, this.data.verificationStatus || this.additional.verificationStatus);
    }
    get type() {
        return $definitions.selects.getValue(ALLERGY_TYPE_SELECT_ID, this.data.type);
    }
    get note() {
        return this.data.note;
    }
}
